import { Component, OnDestroy, OnInit } from '@angular/core';
import { Reservation, Shift } from '@model/reservation';
import { ReservationType } from '@model/tables-plan';
import { Store, select } from '@ngrx/store';
import { State } from '@store/index';
import * as ReservationListSelectors from '@store/selectors/reservation-list.selectors';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Common } from 'src/app/lib/common-methods';
import * as TablesPlanSelectors from '@store/selectors/tables-plan.selectors';

@Component({
  selector: 'app-sidepanel',
  templateUrl: './sidepanel.component.html',
  styleUrl: './sidepanel.component.scss'
})
export class SidepanelComponent implements OnInit, OnDestroy {

  constructor(
    private store: Store<State>,
  ) {

  }

  destroy$: Subject<boolean> = new Subject<boolean>();

  reservations$: Observable<Reservation[]> = this.store.pipe(select(ReservationListSelectors.selectAllReservations));
  reservations: Reservation[] = [];
  selectedShift$: Observable<Shift | null | undefined> = this.store.pipe(select(ReservationListSelectors.selectSelectedShift));
  selectedShift: Shift | null | undefined = null;
  filteredReservations$: Observable<Reservation[]> = this.store.pipe(select(TablesPlanSelectors.selectReservationsFilteredBySelectedTables));
  filteredReservations: Reservation[] = [];
  sidePanelCollapsed$: Observable<boolean> = this.store.pipe(select(TablesPlanSelectors.selectSidePanelCollapsed));
  sidePanelCollapsed: boolean = false;

  waitingType: ReservationType = ReservationType.Waiting;
  bookedType: ReservationType = ReservationType.Booked;
  completedType: ReservationType = ReservationType.Completed;
  pendingType: ReservationType = ReservationType.Pending;
  seatedType: ReservationType = ReservationType.Seated;

  ngOnInit(): void {
    this.reservations$.pipe(takeUntil(this.destroy$)).subscribe((reservations: Reservation[]) => {
      this.reservations = reservations;
    });

    this.selectedShift$.pipe(takeUntil(this.destroy$)).subscribe((selectedShift: Shift | null | undefined) => {
      this.selectedShift = selectedShift;
    });
    
    this.filteredReservations$.pipe(takeUntil(this.destroy$)).subscribe((filteredReservations: Reservation[]) => {
      this.filteredReservations = filteredReservations;
    });

    this.sidePanelCollapsed$.pipe(takeUntil(this.destroy$)).subscribe((sidePanelCollapsed: boolean) => {
      this.sidePanelCollapsed = sidePanelCollapsed;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
